"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-chevron-down viewbox="0 0 24 14"><path d="M2.905-.023l11.542 11.544-2.448 2.449L.455 2.426l2.45-2.449zM9.55 11.521L21.095-.024l2.45 2.449L11.999 13.97 9.55 11.521z"></path></symbol>';
};